export default "__VITE_ASSET__Ct788X4C__"